import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {
  PeriodState,
  FetchPeriodsResponse,
  FetchPeriodByIdResponse,
  FetchAllPeriodsResponse,
} from './types'
import {
  fetchPeriodById,
  fetchPeriods,
  createPeriod,
  updatePeriod,
  deletePeriod,
  suspendPeriod,
  activatePeriod,
  fetchAllPeriods,
} from './service'
import {ResponseError} from '../commonTypes'

const initialState: PeriodState = {
  periodForEdit: null,
  periods: [],
  total: 0,
  totalPages: 0,
  listLoading: false,
  actionLoading: false,
  error: null,
}
const periodSlice = createSlice({
  name: 'period',
  initialState,
  reducers: {
    resetPeriods: (state: PeriodState) => {
      state.periods = []
      state.total = 0
      state.totalPages = 0
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPeriods.pending, (state: PeriodState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(fetchPeriods.rejected, (state: PeriodState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.listLoading = false
    })
    builder.addCase(
      fetchPeriods.fulfilled,
      (state: PeriodState, action: PayloadAction<FetchPeriodsResponse>) => {
        state.listLoading = false
        state.error = null
        const {periods, total, totalPages} = action.payload
        state.periods = periods
        state.total = total
        state.totalPages = totalPages
      }
    )

    builder.addCase(fetchAllPeriods.pending, (state: PeriodState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(fetchAllPeriods.rejected, (state: PeriodState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.listLoading = false
    })
    builder.addCase(
      fetchAllPeriods.fulfilled,
      (state: PeriodState, action: PayloadAction<FetchAllPeriodsResponse>) => {
        state.listLoading = false
        state.error = null
        const {periods} = action.payload
        state.periods = periods
      }
    )

    builder.addCase(fetchPeriodById.pending, (state: PeriodState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(fetchPeriodById.rejected, (state: PeriodState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.listLoading = false
    })
    builder.addCase(
      fetchPeriodById.fulfilled,
      (state: PeriodState, action: PayloadAction<FetchPeriodByIdResponse>) => {
        state.periodForEdit = action.payload.period
        state.listLoading = false
        state.error = null
        state.periodForEdit = action.payload.period
      }
    )

    builder.addCase(createPeriod.pending, (state: PeriodState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(createPeriod.rejected, (state: PeriodState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      createPeriod.fulfilled,
      (state: PeriodState, action: PayloadAction<FetchPeriodByIdResponse>) => {
        state.periodForEdit = action.payload.period
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(updatePeriod.pending, (state: PeriodState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(updatePeriod.rejected, (state: PeriodState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      updatePeriod.fulfilled,
      (state: PeriodState, action: PayloadAction<FetchPeriodByIdResponse>) => {
        state.periodForEdit = action.payload.period
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(deletePeriod.pending, (state: PeriodState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(deletePeriod.rejected, (state: PeriodState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      deletePeriod.fulfilled,
      (state: PeriodState, action: PayloadAction<FetchPeriodByIdResponse>) => {
        state.periodForEdit = action.payload.period
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(suspendPeriod.pending, (state: PeriodState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(suspendPeriod.rejected, (state: PeriodState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      suspendPeriod.fulfilled,
      (state: PeriodState, action: PayloadAction<FetchPeriodByIdResponse>) => {
        state.periodForEdit = action.payload.period
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(activatePeriod.pending, (state: PeriodState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(activatePeriod.rejected, (state: PeriodState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      activatePeriod.fulfilled,
      (state: PeriodState, action: PayloadAction<FetchPeriodByIdResponse>) => {
        state.periodForEdit = action.payload.period
        state.actionLoading = false
        state.error = null
      }
    )
  },
})

export default periodSlice.reducer
export const actions = periodSlice.actions
